export function setToken(token) {
  localStorage.setItem('token', token);
}

export function removeToken() {
  localStorage.removeItem('token');
}

export function getToken() {
  // getItem returns null if there's no string
  const token = localStorage.getItem('token');
  if (!token) return null;

  try {
    // Check if expired, remove if it is
    const payload = JSON.parse(atob(token.split('.')[1]));
    // A JWT's exp is expressed in seconds, not milliseconds, so convert
    if (payload.exp < Date.now() / 1000) {
      removeToken();
      return null;
    }
    return token;
  } catch (err) {
    console.log('Invalid token:', err);
    removeToken();
    return null;
  }
}

export function getUserFromToken() {
  const token = getToken();
  try {
    // If there's a token, return the user in the payload, otherwise return null
    return token ? JSON.parse(atob(token.split('.')[1])).user : null;
  } catch (err) {
    console.error('Failed to parse user from token:', err);
    return null;
  }
}
